import React, { Fragment } from 'react'; // eslint-disable-line

const RadioWithLabel = (props) => {
    return (
        <div className="radio">
            <input data-qa={props.id} id={props.id} type="radio" name={props.name} onClick={props.handleClick} defaultChecked={props.defaultChecked} className="hidden" value={props.value} />
            <label data-qa={`${props.id}__label`} id={`${props.id}__label`}>{props.text}</label>
        </div>
    );
};

export default RadioWithLabel;
